import { ChangeEvent, FormEvent, useState } from "react";
import { ReactComponent as FrameBack } from "../../images/frame_back.svg";
import { ReactComponent as MainLogo } from "./../../images/main-logo.svg";
import { ReactComponent as UserIcon } from "./../../images/person.svg";
import TextField from "@material-ui/core/TextField";
import TalaeraSpinner from "../../components/TalaeraSpinner/TalaeraSpinner";
import { signInSSO } from "../../services/authUtil";
import { TalaeraError } from "../../model/general";
import { getErrorComponents } from "../../services/util";
import "./style.css";
import { Link, useSearchParams } from "react-router-dom";
import TalaeraRoutes from "../../components/routes/TalaeraRoutes";

export default function SignInSSO() {
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState(searchParams.get("email") || "");
  const [error, setError] = useState<TalaeraError | null>(searchParams.get("error"));
  const [loading, setLoading] = useState(false);

  const onSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setError(null);
    setLoading(true);
    let response: { redirect_url: string };
    try {
      response = await signInSSO({ email });
    } catch (e) {
      setError(e as TalaeraError);
      return;
    } finally {
      setLoading(false);
    }

    window.location.replace(response.redirect_url);
  };

  const onEmailChange = (event: ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    setEmail(event.target.value);
  };

  return (
    <div className="sign-in-sso-page">
      <div className="sign-in-content">
        <MainLogo />
        <div className="sign-in-sso-header">
          <UserIcon />
          <h1>Sign In with your corporate account</h1>
        </div>
        {loading && <TalaeraSpinner />}
        {error && getErrorComponents(error)}
        <form onSubmit={onSubmit}>
          <div className="form-wrapper">
            <TextField
              disabled={loading}
              name="email"
              label="Email address"
              placeholder="johnsmith@gmail.com"
              variant="outlined"
              value={email}
              onChange={onEmailChange}
            />
            <button disabled={loading} className="btn" type="submit">
              Sign In
            </button>
            <Link to={TalaeraRoutes.SIGN_IN.path} replace>
              Back To Sign In
            </Link>
          </div>
        </form>
      </div>
      <FrameBack className="sign-in-frame-back" />
    </div>
  );
}
